export enum ClinicalTaskStatus {
  Upcoming = "Upcoming",
  Overdue = "Overdue",
  Today = "Due today",
  Completed = "Completed"
}
